import {isNullOrUndefined} from "../../../services/Validator";

export default function GamesResultsContentLayout({children}) {
    // Used in Games to frame results content

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"bg-backgroundLight5 shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] w-full flex flex-col justify-start items-center rounded-[24px] px-[24px] pt-[16px] pb-[24px] mt-[12px]"}>
            {children}
        </div>
    );
}